(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["endorsements"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.stories').forEach((section) => {
    const track = section.querySelector('[data-stories-track]');
    if (!track) return;

    section.querySelectorAll('[data-stories-dir]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = track.querySelector('.stories__item');
        const step = item ? item.getBoundingClientRect().width + 16 : 360;
        track.scrollBy({ left: step * Number(button.dataset.storiesDir), behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  // Cards rise into place as the row comes into view; a static page of
  // identical panels was the flat part.
  (() => {
    const items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    items.forEach((el) => io.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class SiteHeader {
    constructor(header) {
      this.header = header;
      this.triggers = [...header.querySelectorAll('.header__trigger')];
      this.toggle = header.querySelector('.header__toggle');
      this.drawer = header.querySelector('.header__drawer');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.togglePanel(trigger));
      });

      if (this.triggers.length) {
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.closePanels();
        });
        document.addEventListener('click', (event) => {
          if (!header.contains(event.target)) this.closePanels();
        });
      }

      if (this.toggle && this.drawer) {
        this.toggle.addEventListener('click', () => this.toggleDrawer());
      }

      this.onScroll();
      window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    }

    panelFor(trigger) {
      return this.header.querySelector('#' + trigger.dataset.panel);
    }

    togglePanel(trigger) {
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      this.closePanels();
      if (wasOpen) return;
      trigger.setAttribute('aria-expanded', 'true');
      const panel = this.panelFor(trigger);
      if (panel) panel.hidden = false;
    }

    closePanels() {
      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
        const panel = this.panelFor(trigger);
        if (panel) panel.hidden = true;
      });
    }

    toggleDrawer() {
      const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', String(!isOpen));
      this.drawer.hidden = isOpen;
    }

    onScroll() {
      this.header.classList.toggle('is-stuck', window.scrollY > 60);
    }

    // Fallback for browsers without :has() — see the stylesheet.
    hostSticky() {
      this.header.closest('.shopify-section')?.classList.add('header-sticky-host');
    }

    // The hero pulls itself up by --header-height to sit under the header.
    // Nothing set that variable, so the hero used the fallback and stopped a
    // few pixels short, leaving a strip of page background showing as a line
    // under the announcement bar. Measure it instead of guessing.
    measure() {
      const host = this.header.closest('.shopify-section') || this.header;
      const set = () => {
        const h = host.getBoundingClientRect().height;
        if (h > 0) document.documentElement.style.setProperty('--header-height', h + 'px');
      };
      set();
      window.addEventListener('resize', set);
      window.addEventListener('load', set);
      if (window.ResizeObserver) new ResizeObserver(set).observe(host);
    }
  }

  document.querySelectorAll('.header').forEach((header) => {
    const h = new SiteHeader(header);
    h.hostSticky();
    h.measure();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Draws a drifting network of cells that keep forming and losing links, with
  // an occasional signal running along one. Canvas rather than film: a few KB
  // instead of megabytes, exact brand colours, and no autoplay to be refused.
  (() => {
    const TONES = {
      dark: { node: 'rgba(255, 201, 138, ALPHA)', link: 'rgba(224, 128, 64, ALPHA)', pulse: 'rgba(253, 248, 243, ALPHA)', nodeAlpha: 0.85, linkAlpha: 0.42, pulseAlpha: 0.9 },
      light: { node: 'rgba(176, 92, 40, ALPHA)', link: 'rgba(150, 82, 40, ALPHA)', pulse: 'rgba(224, 128, 64, ALPHA)', nodeAlpha: 0.62, linkAlpha: 0.34, pulseAlpha: 0.8 },
    };

    class Network {
      constructor(canvas) {
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.density = parseFloat(canvas.dataset.neuronsDensity || '1');
        this.tone = TONES[canvas.dataset.neuronsTone] || TONES.dark;
        this.nodes = [];
        this.pulses = [];
        this.running = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.resize();
        window.addEventListener('resize', () => this.resize());

        if (this.reduced) {
          this.draw();
          return;
        }

        new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? this.start() : this.stop()));
        }, { threshold: 0 }).observe(canvas);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
        });
      }

      resize() {
        const rect = this.canvas.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        this.canvas.width = Math.round(rect.width * dpr);
        this.canvas.height = Math.round(rect.height * dpr);
        this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.w = rect.width;
        this.h = rect.height;
        this.linkDist = Math.min(165, Math.max(95, Math.min(this.w, this.h) * 0.3));

        const target = Math.round((this.w * this.h) / 6200 * this.density);
        const count = Math.max(46, Math.min(170, target));
        this.nodes = Array.from({ length: count }, () => {
          // Two depths: a dim slow field behind a brighter, faster one, so the
          // network has somewhere to recede to instead of sitting on one plane.
          const back = Math.random() < 0.45;
          const speed = back ? 0.08 : 0.26;
          return {
            back,
            x: Math.random() * this.w,
            y: Math.random() * this.h,
            vx: (Math.random() - 0.5) * speed,
            vy: (Math.random() - 0.5) * speed,
            r: back ? 0.7 + Math.random() * 0.9 : 1.2 + Math.random() * 2.2,
            phase: Math.random() * Math.PI * 2,
            rate: 0.0008 + Math.random() * 0.0016,
          };
        });
        this.pulses = [];
        if (this.reduced) this.draw();
      }

      start() {
        if (this.running || this.reduced) return;
        this.running = true;
        this.last = performance.now();
        this.tick();
      }

      stop() {
        this.running = false;
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      tick() {
        if (!this.running) return;
        const now = performance.now();
        const dt = Math.min(48, now - this.last);
        this.last = now;
        this.step(dt);
        this.draw();
        this.raf = requestAnimationFrame(() => this.tick());
      }

      step(dt) {
        const k = dt / 16.67;
        this.nodes.forEach((n) => {
          n.x += n.vx * k;
          n.y += n.vy * k;
          if (n.x < -20) n.x = this.w + 20;
          if (n.x > this.w + 20) n.x = -20;
          if (n.y < -20) n.y = this.h + 20;
          if (n.y > this.h + 20) n.y = -20;
        });

        this.clock = (this.clock || 0) + dt;
        this.pulses = this.pulses.filter((p) => (p.t += dt / p.life) < 1);
        const want = Math.max(6, Math.round(this.nodes.length / 9));
        while (this.pulses.length < want && Math.random() < dt / 90) this.spawnPulse();
      }

      spawnPulse() {
        const a = this.nodes[(Math.random() * this.nodes.length) | 0];
        const near = this.nodes.filter((b) => b !== a && Math.hypot(a.x - b.x, a.y - b.y) < this.linkDist);
        if (!near.length) return;
        const b = near[(Math.random() * near.length) | 0];
        this.pulses.push({ a, b, t: 0, life: 520 + Math.random() * 620, r: 1.5 + Math.random() * 1.4 });
      }

      draw() {
        const { ctx } = this;
        ctx.clearRect(0, 0, this.w, this.h);

        // Links fade in as cells drift together and out as they separate.
        for (let i = 0; i < this.nodes.length; i++) {
          for (let j = i + 1; j < this.nodes.length; j++) {
            const a = this.nodes[i];
            const b = this.nodes[j];
            const d = Math.hypot(a.x - b.x, a.y - b.y);
            if (d > this.linkDist) continue;
            const near = 1 - d / this.linkDist;
            const depth = a.back && b.back ? 0.45 : a.back || b.back ? 0.72 : 1;
            const alpha = Math.pow(near, 1.4) * this.tone.linkAlpha * depth;
            ctx.strokeStyle = this.tone.link.replace('ALPHA', alpha.toFixed(3));
            ctx.lineWidth = near > 0.72 ? 1.4 : 1;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.stroke();
          }
        }

        this.pulses.forEach((p) => {
          const e = p.t < 0.5 ? 2 * p.t * p.t : 1 - Math.pow(-2 * p.t + 2, 2) / 2;
          const x = p.a.x + (p.b.x - p.a.x) * e;
          const y = p.a.y + (p.b.y - p.a.y) * e;
          const fade = Math.sin(p.t * Math.PI);
          ctx.fillStyle = this.tone.pulse.replace('ALPHA', (fade * this.tone.pulseAlpha).toFixed(3));
          ctx.shadowColor = this.tone.pulse.replace('ALPHA', (fade * 0.7).toFixed(3));
          ctx.shadowBlur = 10;
          ctx.beginPath();
          ctx.arc(x, y, p.r, 0, Math.PI * 2);
          ctx.fill();
          ctx.shadowBlur = 0;
        });

        const t = this.clock || 0;
        this.nodes.forEach((n) => {
          const twinkle = 0.75 + 0.25 * Math.sin(n.phase + t * n.rate);
          const a = this.tone.nodeAlpha * (n.back ? 0.45 : 1) * twinkle;
          ctx.fillStyle = this.tone.node.replace('ALPHA', a.toFixed(3));
          if (!n.back) {
            ctx.shadowColor = this.tone.node.replace('ALPHA', (a * 0.6).toFixed(3));
            ctx.shadowBlur = 8;
          }
          ctx.beginPath();
          ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
          ctx.fill();
          ctx.shadowBlur = 0;
        });
      }
    }

    // Phones routinely refuse the first autoplay; ask again once visible.
    document.querySelectorAll('.hero__video').forEach((film) => {
      const nudge = () => { const p = film.play(); if (p && p.catch) p.catch(() => {}); };
      new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && film.paused) nudge(); }),
        { threshold: 0.1 }).observe(film);
      document.addEventListener('visibilitychange', () => { if (!document.hidden && film.paused) nudge(); });
    });

    const markHeader = () => {
      if (document.querySelector('.hero--light')) {
        document.querySelectorAll('.header').forEach((h) => h.classList.add('header--on-film'));
        return;
      }
      if (!document.querySelector('.hero--motion')) return;
      document.querySelectorAll('.header').forEach((h) => h.classList.add('header--on-dark'));
    };

    const init = () => (markHeader(), document.querySelectorAll('[data-neurons]').forEach((c) => {
      if (!c.dataset.neuronsReady) {
        c.dataset.neuronsReady = '1';
        new Network(c);
      }
    }));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-quiz"] && !Shopify.designMode) return;
  try {
    
  class RoutineQuiz {
    constructor(root) {
      this.root = root;
      this.intro = root.querySelector('[data-quiz-intro]');
      this.flow = root.querySelector('[data-quiz-flow]');
      this.result = root.querySelector('[data-quiz-result]');
      this.steps = [...root.querySelectorAll('[data-quiz-step]')];
      this.bars = [...root.querySelectorAll('[data-quiz-bar]')];
      this.picks = [];
      this.index = 0;

      root.querySelector('[data-quiz-start]')?.addEventListener('click', () => this.start());
      root.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this.reset());

      this.steps.forEach((step, i) => {
        step.querySelectorAll('[data-quiz-answer]').forEach((button) => {
          button.addEventListener('click', () => this.answer(i, button));
        });
        step.querySelector('[data-quiz-back]')?.addEventListener('click', () => this.back(i));
      });
    }

    start() {
      this.intro.hidden = true;
      this.flow.hidden = false;
      this.show(0);
    }

    show(i) {
      this.index = i;
      this.steps.forEach((step, n) => {
        step.hidden = n !== i;
        const back = step.querySelector('[data-quiz-back]');
        if (back) back.hidden = n === 0;
      });
      this.bars.forEach((bar, n) => bar.classList.toggle('is-done', n <= i));
    }

    answer(i, button) {
      this.picks[i] = {
        url: button.dataset.productUrl,
        title: button.dataset.productTitle,
        image: button.dataset.productImage,
      };
      if (i + 1 < this.steps.length) {
        this.show(i + 1);
      } else {
        this.finish();
      }
    }

    back(i) {
      if (i > 0) this.show(i - 1);
    }

    // The product chosen most often wins; ties fall back to the first answer.
    finish() {
      const tally = new Map();
      this.picks.filter(Boolean).forEach((pick) => {
        if (!pick.url) return;
        const entry = tally.get(pick.url) || { ...pick, n: 0 };
        entry.n += 1;
        tally.set(pick.url, entry);
      });

      const winner = [...tally.values()].sort((a, b) => b.n - a.n)[0];
      if (!winner) return;

      this.flow.hidden = true;
      this.result.hidden = false;
      this.result.querySelector('[data-quiz-result-title]').textContent = winner.title;
      const image = this.result.querySelector('[data-quiz-result-image]');
      if (winner.image) {
        image.src = winner.image;
        image.alt = winner.title;
        image.hidden = false;
      } else {
        image.hidden = true;
      }
      this.result.querySelector('[data-quiz-result-link]').href = winner.url;
    }

    reset() {
      this.picks = [];
      this.result.hidden = true;
      this.flow.hidden = false;
      this.show(0);
    }
  }

  document.querySelectorAll('.quiz').forEach((root) => new RoutineQuiz(root));

  // Let the film run on through the section below the quiz, so the two share
  // one background. Measured rather than guessed — the neighbour's height moves
  // with its copy, its images and the viewport.
  const stretchFilm = () => {
    document.querySelectorAll('.quiz--extend').forEach((quiz) => {
      const host = quiz.closest('.shopify-section') || quiz;
      const next = host.nextElementSibling;
      if (!next) return;
      next.classList.add('quiz-film-follows');
      quiz.style.setProperty('--quiz-film-extend', next.getBoundingClientRect().height + 'px');
    });
  };

  stretchFilm();
  window.addEventListener('resize', stretchFilm);
  window.addEventListener('load', stretchFilm);

  if (window.ResizeObserver) {
    document.querySelectorAll('.quiz--extend').forEach((quiz) => {
      const host = quiz.closest('.shopify-section') || quiz;
      const next = host.nextElementSibling;
      if (next) new ResizeObserver(stretchFilm).observe(next);
    });
  }

  // A second autoplaying video is often deferred; ask again when it scrolls in.
  document.querySelectorAll('.quiz__video').forEach((film) => {
    const nudge = () => { const p = film.play(); if (p && p.catch) p.catch(() => {}); };
    nudge();
    new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && film.paused) nudge(); }),
      { threshold: 0.05 }).observe(film);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && film.paused) nudge(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product').forEach((productElement) => {
    productElement.addEventListener('change', async (event) => {
      const selectors = event.target.closest('.product__options');
      if (!selectors) return;

      const sectionId = selectors.dataset.sectionId;
      const optionValues = Array.from(selectors.querySelectorAll('input[type="radio"]:checked'))
        .map(({ dataset }) => dataset.optionValueId)
        .join(',');

      const response = await fetch(
        `${window.location.pathname}?section_id=${sectionId}&option_values=${optionValues}`,
      );
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = html.querySelector('.product');
      if (!updated) return;

      const focusedId = event.target.id;
      productElement.innerHTML = updated.innerHTML;
      document.getElementById(focusedId)?.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-formula"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-formula]').forEach((panel) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      panel.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        panel.classList.add('is-visible');
        observer.disconnect();
      },
      { threshold: 0.3 },
    );

    observer.observe(panel);
  });

  // Phones routinely refuse the initial autoplay (low-power mode, or the tab
  // was still hidden). Ask again once the film is actually on screen.
  document.querySelectorAll('.formula__backdrop, .formula__clip').forEach((film) => {
    const nudge = () => {
      const play = film.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    };

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && film.paused) nudge();
      });
    }, { threshold: 0.1 }).observe(film);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && film.paused) nudge();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-nutrients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nutrients').forEach((section) => {
    const track = section.querySelector('[data-nutrients-track]');
    if (!track) return;

    const step = () => {
      const card = track.querySelector('.nutrients__card');
      return card ? card.getBoundingClientRect().width + 16 : 320;
    };

    section
      .querySelector('[data-nutrients-prev]')
      ?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    section
      .querySelector('[data-nutrients-next]')
      ?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"]) return;
  try {
    
  // If Judge.me never paints (script blocked, widget not provisioned), fall back
  // to the curated list rather than showing an empty section.
  document.querySelectorAll('.reviews').forEach((section) => {
    const live = section.querySelector('[data-reviews-live]');
    const fallback = section.querySelector('[data-reviews-fallback]');
    if (!live || !fallback) return;

    const painted = () => live.querySelector('.jdgm-rev, .jdgm-write-rev-link, .jdgm-form');

    const settle = () => {
      if (painted()) return true;
      return false;
    };

    if (settle()) return;

    const observer = new MutationObserver(() => {
      if (settle()) observer.disconnect();
    });
    observer.observe(live, { childList: true, subtree: true });

    window.setTimeout(() => {
      observer.disconnect();
      if (painted()) return;

      live.hidden = true;

      // A product with no curated rows and an empty widget (Judge.me hides its
      // own empty state) would leave a heading over nothing — drop the section.
      if (fallback.children.length === 0) {
        section.hidden = true;
        return;
      }

      fallback.hidden = false;
    }, 4000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology"] && !Shopify.designMode) return;
  try {
    
  class StatCounter {
    constructor(element) {
      this.element = element;
      this.output = element.querySelector('.tech__stat-number');
      this.target = parseFloat(element.dataset.countTarget);
      this.suffix = element.dataset.countSuffix || '';
      this.decimals = String(this.target).includes('.') ? 1 : 0;
      this.hasRun = false;

      if (!this.output || Number.isNaN(this.target)) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.render(this.target);
        return;
      }

      this.observer = new IntersectionObserver((entries) => this.onIntersect(entries), {
        threshold: 0.4,
      });
      this.observer.observe(element);
    }

    onIntersect(entries) {
      if (!entries[0].isIntersecting || this.hasRun) return;
      this.hasRun = true;
      this.observer.disconnect();
      this.animate();
    }

    animate() {
      const duration = 1400;
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.render(this.target * eased);
        if (progress < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    }

    render(value) {
      this.output.textContent = value.toFixed(this.decimals) + this.suffix;
    }
  }

  document.querySelectorAll('[data-count-target]').forEach((element) => new StatCounter(element));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.social').forEach((section) => {
    const track = section.querySelector('[data-social-track]');
    if (!track) return;

    section.querySelectorAll('.social__arrow').forEach((button) => {
      button.addEventListener('click', () => {
        const card = track.querySelector('.social__card');
        const step = card ? card.getBoundingClientRect().width + 32 : 320;
        track.scrollBy({ left: step * Number(button.dataset.direction), behavior: 'smooth' });
      });
    });

    // With one card per screen, a short review under a long one left a tall
    // empty gap above the arrows. Fit the track to the card in view instead.
    const cards = [...track.querySelectorAll('.social__card')];
    let frame;
    const fit = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const oneUp = cards[0] && cards[0].offsetWidth >= track.clientWidth * 0.9;
        if (!oneUp) {
          track.style.height = '';
          return;
        }
        const index = Math.round(track.scrollLeft / (cards[0].offsetWidth + 32));
        const card = cards[Math.min(Math.max(index, 0), cards.length - 1)];
        track.style.height = `${card.offsetHeight}px`;
      });
    };
    track.addEventListener('scroll', fit, { passive: true });
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    fit();
  });

  } catch(e) { console.error(e); }
})();
})();
